import { render, staticRenderFns } from "./targetRule.vue?vue&type=template&id=038aaf26&scoped=true"
import script from "./targetRule.vue?vue&type=script&lang=js"
export * from "./targetRule.vue?vue&type=script&lang=js"
import style0 from "./targetRule.vue?vue&type=style&index=0&id=038aaf26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038aaf26",
  null
  
)

export default component.exports